<template>
  <div class="HeaderVue">
    <header :class="{ change_color: scrollBoolean }">
      <div class="space2"></div>
      <div class="logo-container">
        <a href="/">
          <svg
            class="logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 31.3 11.88"
          >
            <title>OCULAR-SYMBOL</title>
            <g id="Illu_white" data-name="Illu white">
              <rect class="cls-1" x="15" y="5.58" width="2.38" height="0.72" />
              <rect class="cls-1" y="5.58" width="0.95" height="0.72" />
              <rect
                class="cls-1"
                x="30.34"
                y="5.58"
                width="0.95"
                height="0.72"
              />
              <path
                class="cls-1"
                d="M7.71,11.88A5.94,5.94,0,0,1,1.77,5.94,5.94,5.94,0,0,1,7.71,0a5.94,5.94,0,0,1,0,11.88Zm0-11a5.11,5.11,0,1,0,5.1,5.11A5.12,5.12,0,0,0,7.71.83Z"
              />
              <path
                class="cls-1"
                d="M24.68,11.88a5.94,5.94,0,0,1-4.2-10.14,5.94,5.94,0,0,1,9.15.91l-.7.46a5.11,5.11,0,1,0,0,5.66l.7.46A6,6,0,0,1,24.68,11.88Z"
              />
            </g>
          </svg>
        </a>
      </div>

      <div class="space"></div>

      <ul class="nav-links" v-bind:class="{ navactive: toggleNav }">
        <router-link class="rou-li" @click.native="navSlide()" to="/"
          >Home</router-link
        >
        <a class="rou-li" href="/#team" v-smooth-scroll>Team</a>
        <router-link class="rou-li" @click.native="navSlide()" to="/projekte"
          >Projekte</router-link
        >
        <a class="rou-li" href="/#footer" v-smooth-scroll>Kontakt</a>
      </ul>
      <div
        class="burger"
        @click="navSlide()"
        v-bind:class="{ toggle: toggleNav }"
      >
        <div class="line1"></div>
        <div class="line2"></div>
        <div class="line3"></div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "HeaderVue",
  data() {
    return {
      toggleNav: false,
      scrollBoolean: false,
      scrollPosition: null,
    };
  },
  methods: {
    navSlide() {
      this.toggleNav = !this.toggleNav;
    },
    checkRoute() {
      if (this.$route.name !== "Home") {
        console.log("ayyyyo, ds isch gheimi nachricht ... pssshht!");
        this.scrollBoolean = true;
      }
    },
    updateScroll() {
      if (this.$route.path === "/") {
        this.scrollPosition = window.scrollY;
        if (this.scrollPosition < 100) {
          this.scrollBoolean = false;
        } else if (this.scrollPosition > 100) {
          this.scrollBoolean = true;
        }
      } else {
        this.scrollBoolean = true;
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.updateScroll);
    window.addEventListener("load", this.checkRoute);
  },
  watch: {
    $route: "updateScroll",
  },
};
</script>

<style lang="scss" scoped>
.change_color {
  background-color: #141d23;
  opacity: 1;
  -webkit-box-shadow: 0px 30px 30px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 30px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 30px 30px rgba(0, 0, 0, 0.1);
  transition: 0.3s ease-in-out;
  .nav-links {
    .rou-li {
      color: #f5f4f3;
    }
  }
  .logo-container {
    .logo {
      fill: #f5f4f3;
    }
  }
}
header {
  display: flex;
  width: 100%;
  min-height: 8vh;
  margin: 0;
  align-items: center;
  justify-content: space-around;
  background: transparent;
  position: fixed;
  z-index: 100;
  transition: 0.3s ease-in-out;
  .burger {
    display: none;
  }
  .logo-container {
    flex: 4;
    display: flex;
    padding-left: 5vw;
    .logo {
      width: 10rem;
      fill: #f5f4f3;
    }
  }
  .nav-links {
    flex: 6;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    list-style: none;
    .rou-li {
      font-size: 1.8rem;
      letter-spacing: 0.1rem;
      text-decoration: none;
      text-transform: capitalize;
      font-weight: 400;
      color: #f5f4f3;
    }
  }
}
@media only screen and (max-width: 1024px) {
  .change_color {
    .burger {
      div {
        background-color: #f5f4f3;
      }
    }
  }
  header {
    overflow-x: hidden;
    min-height: 12vh;
    position: fixed;
    transition: all 0.5s ease-in;
    justify-content: space-around;
    .logo-container {
      justify-content: center;
      padding-left: 7.5rem;
      .logo {
        margin-left: 0vw;
      }
    }
    .nav-links {
      padding: 10vh 0 15vh 0;
      overflow-x: hidden;
      position: fixed;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      right: 0em;
      left: 0em;
      height: 100vh;
      top: 0;
      transform: translateX(100%);
      transition: transform 0.2s ease-in;
      background: #141d23;
      .rou-li {
        color: #f5f4f3;
        font-size: 6vw;
        font-weight: 300;
      }
    }
    .navactive {
      transform: translateX(0%);
    }
    .burger {
      margin-right: 3rem;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      cursor: pointer;
      max-width: 4.5rem;
      div {
        width: 3.5rem;
        height: 0.3rem;
        margin: 0.25rem;
        background-color: #f5f4f3;
        border-radius: 4rem;
        transition: all 0.5s ease;
      }
      .line1 {
        max-width: 2.5rem;
        align-self: flex-end;
      }
      .line3 {
        max-width: 2.5rem;
      }
      .toggle .line1 {
        transform: rotate(-45deg) translate(0rem, 0rem);
        z-index: 100;
        background-color: #141d23;
        position: fixed;
        transition: 0.3s ease;
        max-width: 4rem;
        padding: 0;
      }
      .toggle .line2 {
        opacity: 0;
      }
      .toggle .line3 {
        transform: rotate(45deg) translate(0rem, 0rem);
        z-index: 10;
        background-color: #1f2d35;
        position: fixed;
        max-width: 4rem;
      }
    }
    .toggle {
      div {
        background-color: #f5f4f3;
        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
      }
      .line1 {
        transform: rotate(-45deg) translate(-0.1rem, 0.9rem);
        transition: 0.3s ease;
        max-width: 4rem;
      }
      .line2 {
        opacity: 0;
      }
      .line3 {
        transform: rotate(45deg) translate(-0.3rem, -1rem);
        max-width: 4rem;
      }
    }
  }
}
</style>
